import { render } from "./PotentialAnalysisV2.vue?vue&type=template&id=7505fc8f&scoped=true&lang=pug"
import script from "./PotentialAnalysisV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialAnalysisV2.vue?vue&type=script&setup=true&lang=js"

import "./PotentialAnalysisV2.vue?vue&type=style&index=0&id=7505fc8f&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7505fc8f"]])

export default __exports__